<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div class="main_container">
                <div class="content_info">
                    <div class="container_data">
                        <router-view @back="goBack()"></router-view>
                    </div>
                </div>
                <div class="container_menu">
                    <router-link activeClass="item_selected_menu" class="item_menu" to="general" @click="openDataMenu(0)">
                        <v-tooltip text="Información General">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-info.png" alt="Información General"/>
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="form-management" @click="openDataMenu(1)">
                        <v-tooltip text="Gestión">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-gestiones.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="payment-intention" @click="openDataMenu(2)">
                        <v-tooltip text="Pago Intención">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-pagos.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="pdf-management" @click="openDataMenu(3)">
                        <v-tooltip text="Ver PDF(s)">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-documentos.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="payment-history" @click="openDataMenu(4)" v-if="infoClient.estado === 'Convenio Activo'">
                        <v-tooltip text="Histórico de Pagos">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-abonos.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="agreements" @click="openDataMenu(5)">
                        <v-tooltip text="Convenios">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-convenios.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="management" @click="openDataMenu(6)">
                        <v-tooltip text="Histórico de Gestiones">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-gestiones2.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="telephone" @click="openDataMenu(7)">
                        <v-tooltip text="Teléfono(s)">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-telefono.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="address-management" @click="openDataMenu(8)">
                        <v-tooltip text="Domicilios">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-direcciones.png" />
                            </template>
                        </v-tooltip>
                    </router-link>

                    <router-link activeClass="item_selected_menu" class="item_menu" to="address-endorsement" @click="openDataMenu(9)">
                        <v-tooltip text="Domicilios Avales">
                            <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/images/img-direccion-aval.png" />
                            </template>
                        </v-tooltip>
                    </router-link> 
                </div>
            </div>
        </v-card>
    </div>
    <SnackbarComponent :value="snackbarData"/>
</template>

<script>


import { EncryptService } from '@/services/EncryptService'
import SnackbarComponent from '@/components/Snackbar.vue';
import { ManagementsService } from '@/services/ManagementsService'
import { ResourcesService } from '@/services/ResourcesService'

export default {
    name: "InfoManagementView",
    props: {
        msg: String,
    },
    components: {
        SnackbarComponent,
    },
    data() {
        return {
            idClient: null,
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            dataMenu: 0,
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
        }
    },
    async created() {
        let params = this.$route.params.form
        let strParams = await EncryptService.decrypt(params)
        if (strParams === null) {
            this.snackbarData.description = `No hay datos en la URL.`
            this.snackbarData.openSnackbar = true;
            return;
        }
        let form = JSON.parse(strParams)
        this.idClient = form.id
        await this.getClientInformation();
    },
    methods: {
        goBack() {
            const previous = this.$router.options.history.state.back
            if (previous && previous.startsWith('/SGCCV/')) {
                this.$router.back()
            } else {
                this.$router.push({ name: 'management-search' })
            }
        },
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)

                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        openDataMenu: function (itemMenu) {
            this.dataMenu = itemMenu
            switch (itemMenu) {
                case 0:
                    this.$router.push('general')
                    break;
                case 1:
                    this.$router.push('form-management')
                    break;
                case 2:
                    this.$router.push('payment-intention')
                    break;
                case 3:
                    this.$router.push('pdf-management')
                    break;
                case 4:
                    this.$router.push('payment-history')
                    break;
                case 5:
                    this.$router.push('agreements')
                    break;
                case 6:
                    this.$router.push('management')
                    break;
                case 7:
                    this.$router.push('telephone')
                    break;
                case 8:
                    this.$router.push('address-management')
                    break;
                case 9:
                    this.$router.push('address-endorsement')
                    break;
            }
        },
    },
}
</script>
<style scoped>

    .main_container {
        display: flex;
        flex-direction: row; 
        width: 100%; 
        height: 100%;
    }

    .content_info {
        width: calc(100% - 50px); 
        height: 100%; 
        display: flex; 
        flex-direction: column;
    }

    .container_data {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        width: 100%; 
        flex: 1;
        min-height: 0;
    }

    .container_data :deep(.client-summary) {
        flex-shrink: 0;
    }

    .container_data :deep(.container_submenu) {
        flex: 1;
        min-height: 0;
        height: auto;
    }

    .container_menu {
        width: 50px; 
        height: 100%; 
        border-left: 1px solid #E3E3E3;
        padding-top: 6px;
    }

    .item_menu {
        cursor: pointer;
        
    }
    .item_menu img:hover {
        border-radius: 20px;
        background-color: #E3E3E3;
    }
    .item_menu img {
        margin: 0 5px;
        padding: 7px;
        max-width: 40px;
        max-height: 40px;
    }

    .item_selected_menu img {
        border-radius: 20px;
        background-color: #cccccc;
    }
</style>